import {
  ComponentInfo,
  ErrorMonitor,
  IBMModuleParams,
  IHttpClient,
  ModuleInfo,
  SentryHub,
} from '@wix/yoshi-flow-bm';
import React, { ReactNode, useState } from 'react';
import { CairoProvider } from '../providers';
import { buildBMCairoEssentials } from './buildBMCairoEssentials';
import {
  WixPatternsEssentialsOverrides,
  Experiments,
  getExperimentsCompat,
} from '@wix/bex-core';

export interface WixPatternsBMGenericFlowAPI {
  moduleParams: IBMModuleParams;
  moduleInfo: ModuleInfo;
  componentInfo?: ComponentInfo;
  errorMonitor: ErrorMonitor;
  httpClient: IHttpClient;
  experiments: Experiments;
  sentry: SentryHub;
}

export interface WixPatternsBMGenericProviderProps {
  flowAPI: WixPatternsBMGenericFlowAPI;
  overrides?: Partial<WixPatternsEssentialsOverrides>;
  children?: ReactNode;
  localCache?: boolean;
}

export function CairoBMGenericProvider({
  overrides,
  flowAPI: flowAPIOriginal,
  children,
  localCache,
}: WixPatternsBMGenericProviderProps) {
  const [errorMonitor] = useState(() => {
    try {
      return flowAPIOriginal.errorMonitor;
    } catch (e) {
      return flowAPIOriginal.sentry as ErrorMonitor;
    }
  });

  const [flowAPI] = useState(() => {
    return {
      moduleParams: flowAPIOriginal.moduleParams,
      moduleInfo: flowAPIOriginal.moduleInfo,
      httpClient: flowAPIOriginal.httpClient,
      experiments: getExperimentsCompat(flowAPIOriginal),
      componentInfo: flowAPIOriginal.componentInfo,
      errorMonitor,
    };
  });

  const [cairoEssentials] = useState(() => {
    return buildBMCairoEssentials(flowAPI, {
      overrides,
    });
  });

  return (
    <CairoProvider value={cairoEssentials} localCache={localCache}>
      {children}
    </CairoProvider>
  );
}
